import { ChevronsLeft } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ChevronsLeftIcon = createLucideIcon(ChevronsLeft);
